import { useContext } from "react";
import { CommunityGroupsContext } from "@/providers/CommunityGroupsProvider";

export const useCommunityGroups = () => {
  const context = useContext(CommunityGroupsContext);
  if (context === undefined) {
    throw new Error("useCommunityGroups must be used within a CommunityGroupsProvider");
  }
  return context;
};
